var _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 38,
    viewBox: "0 0 66 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.99094,
    y1: 18.9065,
    x2: 63.0214,
    y2: 19.0921,
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 2,
    x2: 63,
    y2: 2,
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 36,
    x2: 63,
    y2: 36,
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerDark);
export default __webpack_public_path__ + "static/media/hamburger-dark.041d67d7a2fddec2c4ea818d4f66541b.svg";
export { ForwardRef as ReactComponent };